import React, { Component } from 'react';
import global from "../../global.css";
import { connect } from "react-redux";
import classes from "./Refund.css";
import RefundList from './RefundList/RefundList';
import RefundFrom from './RefundFrom/RefundForm';

class Refund extends Component {
    render() {
        return (
            <div >
                <div className={classes.firstBox}>
                    <div className={[classes.RefundTop, global.Responsive].join(" ")}>
                        
                    <h1>  برای استرداد آنلاین بلیط به  سایت زیر مراجعه کنید</h1>

                    <div class="text-center">
                        <h1 class="display-4">
                            <br />
                            <button className="btn btn-success ">
                        <a href="http://ref.mehrabseir.ir/" style={{color:'#fff'}}>ورود به سایت</a>
                        </button>
                        </h1>
                    </div>
                    </div>
                </div>
                {this.props.loginwithMobile || localStorage["LOG_IN_WITH_PHONE"]
                    ? <div className={classes.Middlepart}>
                        <div className={global.Responsive}>
                            <RefundList />
                        </div>
                    </div>
                    : null
                }
                {/* <div className={classes.FormPart}>
                    <div className={[global.Responsive, classes.RefundForm].join(" ")}>
                        <RefundFrom />
                    </div>
                </div> */}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        loginwithMobile: state.MOBILE.loginwithMobile
    }
}

export default connect(mapStateToProps)(Refund)